module.exports = __webpack_public_path__ + "img/arrow.75cf7f67.svg";